import { StockDataPoint, MetricKey } from '../types/StockData';

// Helper function to calculate options flow metrics
export const getOptionsMetric = (point: StockDataPoint, metricKey: MetricKey): number => {
  const optionsFlow = point.optionFlowInWindow;
  
  if (!optionsFlow) return 0;
  
  switch (metricKey) {
    case 'callBidAskRatio':
      return optionsFlow.callBidAskRatio ?? 0;
    case 'putBidAskRatio':
      return optionsFlow.putBidAskRatio ?? 0;
    case 'callPutVolumeRatio':
      return optionsFlow.callPutVolumeRatio ?? 0;
    case 'optionsCallVolume':
      return optionsFlow.call_volume;
    case 'optionsPutVolume':
      return optionsFlow.put_volume;
    case 'optionsTotalVolume':
      return optionsFlow.totalVolume;
    case 'optionsTotalPremium':
      return optionsFlow.totalNetPremium;
    case 'callBidVolume':
      return optionsFlow.call_volume_bid_side;
    case 'callAskVolume':
      return optionsFlow.call_volume_ask_side;
    case 'putBidVolume':
      return optionsFlow.put_volume_bid_side;
    case 'putAskVolume':
      return optionsFlow.put_volume_ask_side;
    case 'ldpm':
      return point.ldpm?.ldpm ?? 0;
    default:
      return point[metricKey] as number;
  }
};
